module.exports = __webpack_public_path__ + "static/media/financial-stress-and-thinking@2x.4e7d057a.png";